/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentPlanMarketingTile } from './PaymentPlanMarketingTile';
import {
    PaymentPlanMarketingTileFromJSON,
    PaymentPlanMarketingTileFromJSONTyped,
    PaymentPlanMarketingTileToJSON,
} from './PaymentPlanMarketingTile';

/**
 * Ops-editable marketing copy shown on the subscribe intro screen.
 * @export
 * @interface PaymentPlanMarketing
 */
export interface PaymentPlanMarketing {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanMarketing
     */
    headline?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanMarketing
     */
    subhead?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanMarketing
     */
    intro?: string;
    /**
     * Short line rendered above the tiles, e.g. 'Everything in Family Practice, plus:'
     * @type {string}
     * @memberof PaymentPlanMarketing
     */
    includes?: string;
    /**
     * 
     * @type {Array<PaymentPlanMarketingTile>}
     * @memberof PaymentPlanMarketing
     */
    tiles?: Array<PaymentPlanMarketingTile>;
}

/**
 * Check if a given object implements the PaymentPlanMarketing interface.
 */
export function instanceOfPaymentPlanMarketing(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentPlanMarketingFromJSON(json: any): PaymentPlanMarketing {
    return PaymentPlanMarketingFromJSONTyped(json, false);
}

export function PaymentPlanMarketingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlanMarketing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'headline': !exists(json, 'headline') ? undefined : json['headline'],
        'subhead': !exists(json, 'subhead') ? undefined : json['subhead'],
        'intro': !exists(json, 'intro') ? undefined : json['intro'],
        'includes': !exists(json, 'includes') ? undefined : json['includes'],
        'tiles': !exists(json, 'tiles') ? undefined : ((json['tiles'] as Array<any>).map(PaymentPlanMarketingTileFromJSON)),
    };
}

export function PaymentPlanMarketingToJSON(value?: PaymentPlanMarketing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'headline': value.headline,
        'subhead': value.subhead,
        'intro': value.intro,
        'includes': value.includes,
        'tiles': value.tiles === undefined ? undefined : ((value.tiles as Array<any>).map(PaymentPlanMarketingTileToJSON)),
    };
}

